'use client';

import React, { useRef } from 'react';

function CopyEmail() {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const [isCopied, setCopied] = React.useState(false);

  const handleEmailCopy = () => {
    try {
      window.flutter_inappwebview.callHandler('handleAppLink', [
        {
          url: 'store@giftifan.com',
          scheme: 'email',
        },
      ]);
    } catch (e) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      setCopied(true);
      navigator.clipboard.writeText('store@giftifan.com');
      intervalRef.current = setInterval(() => {
        setCopied(false);
      }, 1000);
    }
  };

  return (
    <button
      className="font-bold text-xl mb-4 md:mb-[77px] text-start"
      onClick={handleEmailCopy}
    >
      {isCopied ? 'Copied' : '∙ store@giftifan.com'}
    </button>
  );
}

export default CopyEmail;
